__turbopack_context__.v({
  "badge": "SelectionList-module-scss-module__V67yUW__badge",
  "badge_black": "SelectionList-module-scss-module__V67yUW__badge_black",
  "badge_blue": "SelectionList-module-scss-module__V67yUW__badge_blue",
  "badge_gray": "SelectionList-module-scss-module__V67yUW__badge_gray",
  "badge_green": "SelectionList-module-scss-module__V67yUW__badge_green",
  "badge_primary": "SelectionList-module-scss-module__V67yUW__badge_primary",
  "badge_purple": "SelectionList-module-scss-module__V67yUW__badge_purple",
  "badge_red": "SelectionList-module-scss-module__V67yUW__badge_red",
  "badge_yellow": "SelectionList-module-scss-module__V67yUW__badge_yellow",
  "body": "SelectionList-module-scss-module__V67yUW__body",
  "control_slot": "SelectionList-module-scss-module__V67yUW__control_slot",
  "item": "SelectionList-module-scss-module__V67yUW__item",
  "item_checked": "SelectionList-module-scss-module__V67yUW__item_checked",
  "item_disabled": "SelectionList-module-scss-module__V67yUW__item_disabled",
  "item_inner": "SelectionList-module-scss-module__V67yUW__item_inner",
  "label": "SelectionList-module-scss-module__V67yUW__label",
  "label_row": "SelectionList-module-scss-module__V67yUW__label_row",
  "list": "SelectionList-module-scss-module__V67yUW__list",
  "sub_label": "SelectionList-module-scss-module__V67yUW__sub_label",
  "thumbnail": "SelectionList-module-scss-module__V67yUW__thumbnail",
  "thumbnail_placeholder": "SelectionList-module-scss-module__V67yUW__thumbnail_placeholder",
  "thumbnail_wrap": "SelectionList-module-scss-module__V67yUW__thumbnail_wrap",
});
